<template>
  <div id="app" class="app">
    <header class="header"  id="home">
      <nav class="header_navbar">
        <ul class="header_navbar_menu">
          <li class="header_navbar_menu_link"><a class="header_navbar_menu_link_href" href="#home">Strona Główna</a></li>
          <li class="header_navbar_menu_link"><a class="header_navbar_menu_link_href" href="#aboutUs">O nas</a></li>
          <li class="header_navbar_menu_link"><a class="header_navbar_menu_link_href" href="#members">Nasza kompania</a></li>
          <li class="header_navbar_menu_link"><a class="header_navbar_menu_link_href" href="#events">Larpy</a></li>
        </ul>
      </nav>
      <div class="header_title">
        <h1 class="header_title_name">KRASJA</h1>
        <hr class="header_title_line">
        <h2 class="header_title_slogan"> Daj się porwać w wir przygody!</h2>
      </div>
    </header>
    <home></home>
  </div>
</template>

<script>
  import home from './views/homeView.vue'

  export default {
    components: {
      home
    }
  }
</script>

<style lang="scss">
  @import "../static/style/style.scss";
</style>



// WEBPACK FOOTER //
// App.vue?78d662be